var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplateQanda01 = function SvgTemplateQanda01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "template_qanda-01_svg2__a",
    x1: -19.5,
    x2: 109.77,
    y1: 100.71,
    y2: -28.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__b",
    x1: -20.83,
    x2: 108.44,
    y1: 99.38,
    y2: -29.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__c",
    x1: 16.03,
    x2: 145.3,
    y1: 136.24,
    y2: 6.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__d",
    x1: 19.81,
    x2: 149.08,
    y1: 140.02,
    y2: 10.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__e",
    x1: 16.55,
    x2: 145.82,
    y1: 136.76,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__f",
    x1: 15.22,
    x2: 144.49,
    y1: 135.43,
    y2: 6.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__g",
    x1: 52.09,
    x2: 181.35,
    y1: 172.3,
    y2: 43.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__h",
    x1: 55.86,
    x2: 185.13,
    y1: 176.07,
    y2: 46.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__i",
    x1: 52.6,
    x2: 181.87,
    y1: 172.81,
    y2: 43.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__j",
    x1: 51.27,
    x2: 180.54,
    y1: 171.48,
    y2: 42.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__k",
    x1: 88.14,
    x2: 217.4,
    y1: 208.35,
    y2: 79.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_qanda-01_svg2__a",
    id: "template_qanda-01_svg2__l",
    x1: 91.92,
    x2: 221.18,
    y1: 212.13,
    y2: 82.86
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.31 0C37.92 0 25.39 12.52 25.39 27.92S37.91 55.8 53.31 55.8s27.92-12.51 27.92-27.88S68.71 0 53.31 0m0 49.55c-11.95 0-21.67-9.7-21.67-21.63S41.36 6.25 53.31 6.25s21.67 9.72 21.67 21.67-9.72 21.63-21.67 21.63",
    style: {
      fill: "url(#template_qanda-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.68 19.77-9.63 9.63-3.11-3.11a3.126 3.126 0 0 0-4.42 4.42l5.32 5.32a3.12 3.12 0 0 0 4.42 0L64.1 24.19a3.126 3.126 0 0 0-4.42-4.42",
    style: {
      fill: "url(#template_qanda-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 20.81h73.77c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13",
    style: {
      fill: "url(#template_qanda-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 41.24h48.03c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13",
    style: {
      fill: "url(#template_qanda-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31 72.1c-15.39 0-27.92 12.52-27.92 27.92s12.52 27.88 27.92 27.88 27.92-12.51 27.92-27.88S68.71 72.1 53.31 72.1m0 49.55c-11.95 0-21.67-9.7-21.67-21.63s9.72-21.67 21.67-21.67 21.67 9.72 21.67 21.67-9.72 21.63-21.67 21.63",
    style: {
      fill: "url(#template_qanda-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.68 91.87-9.63 9.63-3.11-3.11a3.126 3.126 0 0 0-4.42 4.42l5.32 5.32c.61.61 1.41.92 2.21.92s1.6-.31 2.21-.92L64.1 96.29a3.126 3.126 0 0 0-4.42-4.42",
    style: {
      fill: "url(#template_qanda-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48 86.66H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h73.77c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#template_qanda-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 113.34h48.03c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13",
    style: {
      fill: "url(#template_qanda-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31 144.2c-15.39 0-27.92 12.52-27.92 27.92S37.91 200 53.31 200s27.92-12.51 27.92-27.88-12.52-27.92-27.92-27.92m0 49.55c-11.95 0-21.67-9.7-21.67-21.63s9.72-21.67 21.67-21.67 21.67 9.72 21.67 21.67-9.72 21.63-21.67 21.63",
    style: {
      fill: "url(#template_qanda-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.68 163.97-9.63 9.63-3.11-3.11a3.126 3.126 0 0 0-4.42 4.42l5.32 5.32c.61.61 1.41.92 2.21.92s1.6-.31 2.21-.92l11.84-11.84a3.126 3.126 0 0 0-4.42-4.42",
    style: {
      fill: "url(#template_qanda-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48 158.76H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h73.77c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#template_qanda-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.74 179.19H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h48.03c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#template_qanda-01_svg2__l)"
    }
  }));
};
export default SvgTemplateQanda01;